// extracted by mini-css-extract-plugin
export default {"emailShow":"tooltip_emailShow__QJFNr","emailText":"tooltip_emailText__1mgpw"};